export const RouteKeys = {
    INVITE: '/',
    STATISTICS: '/statistics',
};
  